// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"80":"datasetQuery","943":"dokumentacija"}[chunkId] + "." + {"80":"00f525ba","943":"fdd33f31"}[chunkId] + ".js";
};